module.exports = __webpack_public_path__ + "img/kid4.453cc719.png";